import React from "react";
import App from "./components/app/app";
import reportWebVitals from "./reportWebVitals";
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from "react-router-dom";
import "./i18n";
import "./types";
import { ConfigProvider } from 'antd';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <BrowserRouter>
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#3B3F45',
                    colorInfo: 'rgb(82 125 255 / 0.3)',
                    colorLink: '#3B3F45',
                },
                components: {
                    Button: {
                        defaultShadow: 'none',
                        primaryShadow: 'none',
                        dangerShadow: 'none',
                    },
                    Table: {
                        rowSelectedBg: '#e8e8e8',
                        rowSelectedHoverBg: '#dedede',
                    },
                },
            }}
        >
            <App />
        </ConfigProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
